import React from "react";

export default function ReservationStepNotice({step, children, mixed = false, className = ""}) {
    const classes = ["kav-demo-step-banner", className].filter(Boolean).join(" ");

    return (
        <div className={classes}>
            <span className="kav-demo-step-banner__badge">{step}</span>
            <p className={mixed ? "kav-demo-step-banner__mixedText" : ""}>
                {children}
            </p>
        </div>
    );
}
